import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'ReadMe Case Study | Canny';
const Description =
  'Read about how ReadMe uses Canny to build the most impactful features for their customers.';
const Image = 'https://canny.io/images/canny-social.png';

export default class ReadmeLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/readme' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
